<template>
    <div class="product-index">
        <div>
            <swiper :swiperSlides="swiperSlides" :options="swiperOption"></swiper>
        </div>
        <section>
            <div>
                <!--alpha-->
                <div class="progress-cont " id="alpha">
                    <div class="suit center">
                        <h2 class="common-font">Alpha Product Suite</h2>
                        <div class="suit-cont">
                            <p v-for="item in suit">{{item}}</p>
                        </div>
                    </div>
                    <!--options-->
                    <div class="progress center">
                        <h2 class="common-font">Principles of Operation</h2>
                        <img src="/static/image/product/process@1x.png" _src="/static/image/product/process@2x.png"
                             alt="">
                    </div>
                </div>
                <!--station-->
                <div class="product-Station center" id="AlphaStation">
                    <productList :proFunction="proStation"></productList>
                </div>
            </div>

        </section>
    </div>
</template>

<script>
    import swiper from '../common/swiper';
    import productList from '../common/productList';
    import proFunction from '../assets/js/productList'

    export default {
        name: "Alpha",

        data() {
            return {
                //轮播图option
                swiperOption: {
                    notNextTick: true,
                    // swiper configs 所有的配置同swiper官方api配置
                    autoplay: true,
                    speed: 2000,
                    loop: 'true',
                    direction: 'horizontal',
                    // grabCursor : true,
                    // autoHeight: true,
                    paginationClickable: true,
                    setWrapperSize: true,
                    observer: true,
                    observeParents: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: 'true'
                    }
                },
                //轮播图
                swiperSlides: [
                    {
                        url: '/static/image/product/banner1@1x.png',
                        url1: '/static/image/product/banner1@2x.png',
                        title: 'Alpha Base Station',
                        content: '30 minutes to build a carrier-class sensor data network Out of the box, license-free ISM band, non-intrusive deployment',
                        icons: [
                            {
                                iconUrl: '/static/image/product/redbot@1x.png',
                                iconUrl1:'/static/image/product/redbot@2x.png'
                            },
                            {

                                iconUrl:'/static/image/product/idea@1x.png' ,
                                iconUrl1:'/static/image/product/idea@2x.png'
                            }

        ]


                    },
                    {
                        url: '/static/image/product/banner2@1x.png',
                        url1: '/static/image/product/banner2@2x.png',
                        title: 'Alpha Gateway',
                        content: 'The integral design of iF awarded Alpha Gateway is concise and efficient, adapting to apply in multiple scenarios',
                        icons: [
                            {
                                iconUrl:'/static/image/product/if@1x.png',
                                iconUrl1:'/static/image/product/if@2x.png'
                            }
                        ]



                    }
                ],
                //产品列表  产品功能  station
                proFunction: proFunction.proFunction,
                proList: proFunction.proList,
                proStation: proFunction.proStation,
                //suit信息
                suit: [
                    'SENSORO\'s Alpha Product Suite provides long-range, low-power capabilities for IoT sensor networks. Unlike other solutions that are difficult to manage and configure and are limited in range, the Alpha platform is simple to implement with an easily managed network that can span over 120 square miles while supporting thousands of sensor devices.',
                    'The network architecture is configured in a simple star topology with the base station relaying information between deployed IoT sensor devices and the centralized management platform on the network backend. The system uses a long-range, low-power IoT-WAN for exchanging data with the sensor devices, and Ethernet and 3G to exchange data with the management platform residing on the Internet or internal network.'
                ]
            }
        },
        mounted() {
            this.utils.getImg()
        },
        components: {
            swiper,
            productList
        }

    }
</script>

<style lang="less">
    .product-index {
        @baseWidth: 1640px;
        .common-font{
            font-family: 'Gotham-Medium',"Avenir Next", 'Helvetica Neue', 'PingFang SC';
            font-weight: 500;
        }
        .center {
            width: @baseWidth;
            margin: 0 auto;
        }
        .swiper-container {
            .swiper-wrapper {
                .swiper-center {
                    width: @baseWidth;
                    height: 100%;
                    margin: 0 auto;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    img {
                        width: 740px;
                        height: 100%;
                    }
                }

                .swiper-slide {
                    height: 530px;
                    background: #383838;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .product-swiper {
                        width: 740px;
                    }
                    .swipwer-center {
                        width: @baseWidth;
                        margin: 0 auto;
                    }
                    .ban-pro {
                        width: 620px;

                        h1 {
                            font-size: 40px;
                            line-height: 64px;
                            color: #FFFFFF;
                            font-weight: 300;
                            font-family: 'Gotham-Medium',"Avenir Next", 'Helvetica Neue', 'PingFang SC';
                        }
                        p {
                            font-size: 16px;
                            color: #B6B6B6;
                            line-height: 26px;
                            margin: 21px 0 24px;
                        }

                        i {
                            display: inline-block;
                            width: 140px;
                            height: 34px;
                            margin-right: 46px;
                            text-align: left;
                            background-position: left!important;
                            background-size: contain !important;
                        }
                    }

                }

            }
            .swiper-pagination-bullets {
                .swiper-pagination-bullet {
                    width: 12px;
                    height: 12px;
                    background: rgba(255, 255, 255, .7);
                    margin-bottom: 28px;

                }
                .swiper-pagination-bullet-active {
                    background: #fff;
                }
            }
        }
        section {
            width: 100%;
            .product-Fun {
                border-bottom: 1px solid #DFDFDF;
            }
            .product-List {
                margin-top: 96px;
                .product-list {
                    .product-info {
                        margin-bottom: 96px;
                        img {
                            width: 380px;
                            height: 380px;
                        }
                    }
                }
            }
            .product-Station {
                margin-top: 96px;
                .product-list {
                    .product-info {
                        margin-bottom: 96px;
                        img {
                            width: 380px;
                            height: 380px;
                        }
                        .product-mes {
                            .product-pro {
                                h2 {
                                    font-size: 14px;
                                    color: #5D5D5D;
                                    line-height: 22px;

                                }
                            }
                        }
                    }
                }
            }
            .progress-cont {
                width: 100%;
                background: #fafafa;
                padding-bottom: 96px;
                h2 {
                    font-size: 28px;
                    color: #252525;
                    text-align: center;
                    line-height: 48px;
                }
                p {
                    font-size: 14px;
                    color: #5D5D5D;
                    letter-spacing: 0;
                    line-height: 22px;
                }
                .suit {
                    padding: 96px 140px;

                    h2 {
                        margin-bottom: 40px;
                    }
                    p {
                        width: 660px;
                    }
                    .suit-cont {
                        display: flex;
                        justify-content: space-between;
                    }
                }
                .progress {
                    width: 1280px;
                    margin: 0 auto;
                    h2 {
                        margin-bottom: 69px;
                    }
                    img {
                        width: 100%;
                        display: block;
                        margin: 0 auto;
                    }
                }
            }
        }

    }

    @media screen and (max-width: 1680px) {
        @baseWidth: 1216px;
        @autoWidth: 1256px;
        .product-index {
            width: 100%;
            min-width: @autoWidth;
            .center {
                width: @baseWidth;
                margin: 0 auto;
            }
            .swiper-container {
                .swiper-wrapper {
                    .swiper-center {
                        width: @baseWidth;
                    }
                    .swiper-slide {
                        padding: 0;
                        .ban-pro {
                            width: 460px;
                        }
                    }
                }
            }
            section {
                /*margin-top: 96px;*/
                .product-List, .product-Station {
                    .product-list {
                        width: 1005px;
                        margin: 0 auto;
                        /*padding:0 100px;*/
                        .product-info {
                            display: block;
                            width: 380px;
                            h1 {
                                text-align: center;
                            }
                            .product-mes {
                                a {
                                    text-align: center;
                                }
                            }
                            img {
                                width: 260px;
                                height: 260px;
                                /*margin: 0 auto;*/
                                margin-left: 60px;
                            }
                        }
                    }
                }
                .product-List, .product-Fun {
                    .product-list {
                        justify-content: space-around;
                    }
                }
                .progress-cont {

                    .suit {
                        padding: 96px 0;
                        p {
                            width: 588px;
                        }
                        .suit-cont {
                            display: flex;
                            justify-content: space-between;
                        }
                    }
                    .progress {
                        h2 {
                            margin-bottom: 69px;
                        }
                        img {
                            display: block;
                            margin: 0 auto;
                            width: 100%;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Alpha.vue